import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

// Components
import { Section } from 'react-bulma-components';

const Email = () => {
    return (
        <Section>
            <h1>Financial</h1>
            <hr />
        </Section>
    );
}

export default Email;
